module.exports = __webpack_public_path__ + "static/images/earning-potential.f882861e4836cd12de0d03c47cbd706e.svg";